import scheduling from './scheduling';

export default [].concat(
  scheduling
);
